<div id="quizCompletion">
    <survey [model]="model"></survey>
</div>